// import React from "react";

// /**
//  * Compact balance / metric card — shared visual language for Customer + Admin.
//  */
// const MiniStatCard = ({
//   title,
//   value,
//   icon,
//   onClick,
//   className = "",
// }) => {
//   return (
//     <div
//       role={onClick ? "button" : undefined}
//       tabIndex={onClick ? 0 : undefined}
//       onClick={onClick}
//       onKeyDown={(e) => {
//         if (onClick && (e.key === "Enter" || e.key === " ")) onClick();
//       }}
//       className={`ds-card ds-mini-stat flex items-center gap-3 min-h-[84px] ${
//         onClick ? "cursor-pointer" : "cursor-default"
//       } ${className}`.trim()}
//     >
//       <div className="flex-1 min-w-0">
//         <p className="text-[13px] font-semibold text-[var(--text-muted)] mb-1">
//           {title}
//         </p>
//         <p className="text-[18px] font-semibold text-[var(--text-dark)] leading-tight tabular-nums">
//           {value}
//         </p>
//       </div>
//       {icon && (
//         <div
//           className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full
//           bg-primary-soft make-text-primary"
//         >
//           {icon}
//         </div>
//       )}
//     </div>
//   );
// };

// export default MiniStatCard;



import React from "react";

/**
 * Compact balance / metric card
 * Shared visual language for Customer + Admin.
 */
const MiniStatCard = ({
  title,
  value,
  icon,
  onClick,
  className = "",
}) => {
  return (
    <div
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(e) => {
        if (onClick && (e.key === "Enter" || e.key === " ")) {
          onClick();
        }
      }}
      className={`
        ds-card
        ds-mini-stat
        flex
        items-center
        gap-3
        min-h-[84px]
        p-4
        ${
          onClick
            ? "cursor-pointer"
            : "cursor-default"
        }
        ${className}
      `.trim()}
    >
      <div className="flex-1 min-w-0">
        <p className="text-[13px] font-semibold text-[var(--text-muted)] mb-1">
          {title}
        </p>

        <p className="text-[18px] font-semibold text-[var(--text-dark)] leading-tight tabular-nums">
          {value}
        </p>
      </div>

      {icon && (
        <div
          className="
            w-10
            h-10
            flex-shrink-0
            flex
            items-center
            justify-center
            rounded-full
            bg-primary-soft
            make-text-primary
          "
        >
          {icon}
        </div>
      )}
    </div>
  );
};

export default MiniStatCard;